import { type PaginationState, type SortingState } from '@tanstack/react-table'
import { useState } from 'react'

import TasksContext from 'components/context/TasksContext'
import { getTasksQueryKey } from 'components/hooks/tasks/useGetTasks'

import TasksTable from './TasksTable'

type TasksMembersViewProps = {
  memberId: string
}

const TasksMembersView = ({
  memberId,
}: TasksMembersViewProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  })
  // No default sorting for the tasks table.
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'created_at', desc: true },
  ])

  return (
    <TasksContext.Provider
      value={{
        getTasksQueryKey: getTasksQueryKey({
          filters: { member_ids: [memberId] },
          pagination,
          sorting,
        }),
      }}
    >
      <div className='flex-col w-full h-full space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
        <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
          <div className='heading-md'>Tasks</div>
        </div>
        <TasksTable
          filters={{ member_ids: [memberId] }}
          pagination={pagination}
          setPagination={setPagination}
          sorting={sorting}
          setSorting={setSorting}
          columnVisibilityOverrides={{
            job_type: false,
            member_name: false,
          }}
          actionsVisibilityOverrides={{
            openInNewTab: true,
          }}
        />
      </div>
    </TasksContext.Provider>
  )
}

export default TasksMembersView
